import Home from '../pages/home.vue';
import PrintBill from '../pages/print-bill.vue';

import ar from '@/local/ar.js';
export default [
  {
    path: '/judicial-fees',
    name: 'judicial-fees',
    component: Home,
    meta: {
      breadcrumbs: {
        hide: true,
        onBase: true,
        text: ar.breadcrumbs.judicialFees,
        isDynamic: false,
      },
    },
  },
  {
    path: '/judicial-fees/:objectKey/print',
    name: 'print-bill',
    component: PrintBill,
    meta: { noBreadcrumbs: true },
  },
];
